import { currencyFormatter } from "../formatter";

export const formatMoney = (value = 0) => {
  return currencyFormatter(value);
};
